import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import App from "./App";
import BlogSection from "./components/blog/BlogSection";
import Login from "./components/auth/Login";
import DashBoard from "./components/dashboard/DashBoard";
import ProtectedRoute from "./components/ProtectedRoute";
import TermsAndConditions from "./components/app/TermsAndConditions";
import AcceptableUsePolicy from "./components/app/AcceptableUsePolicy";
import CookiesPolicy from "./components/app/CookiesPolicy";
import Disclaimer from "./components/app/Disclaimer";
import PrivacyPolicy from "./components/app/PrivacyPolicy";
import LogisticPage from "./pages/logistic/LogisticPage";
import AgentWizard from "./components/app/AgentWizard";

const Main: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Ruta para login */}
        <Route path="/login" element={<Login />} />

        {/* Ruta para la página de blogs */}
        <Route path="/blogs/*" element={<BlogSection/>} />

        {/* Ruta para terminos y condiciones */}
        <Route path="/terms" element={<TermsAndConditions />} />

        {/* Ruta para política de uso aceptable */}
        <Route path="/acceptable-use-policy" element={<AcceptableUsePolicy />} />

        {/* Ruta para política de cookies */}
        <Route path="/cookies-policy" element={<CookiesPolicy />} />

        {/* Ruta para descargo de responsabilidad */}
        <Route path="/disclaimer" element={<Disclaimer />} />

        {/* Ruta para política de privacidad */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/* Ruta para dashboard */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard/*" element={<DashBoard />} />
        </Route>

        <Route path="/logistic" element={<LogisticPage />} />

        {/* Wizard para crear tu agente de voz en 3 minutos */}
        <Route path="/create-agent" element={<AgentWizard />} />

        {/* Ruta principal muestra todos tus componentes */}
        <Route path="/*" element={<App />} />
      </Routes>
    </Router>
  );
};

export default Main;